import { render, staticRenderFns } from "./index20220421.vue?vue&type=template&id=4bb6989e&scoped=true"
import script from "./index20220421.vue?vue&type=script&lang=js"
export * from "./index20220421.vue?vue&type=script&lang=js"
import style0 from "./index20220421.vue?vue&type=style&index=0&id=4bb6989e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6989e",
  null
  
)

export default component.exports